import { useDataProvider, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IShowPdfButton {
  documentNo: string;
  isUnposted?: boolean;
}

const ShowPdfButton = ({ documentNo, isUnposted }: IShowPdfButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const docType = documentNo.substring(0, 2);

  const getPdfUrl = () => {
    provider
      .customGetOne(`customerLedgers/invoiceNo/${documentNo}`)
      .then(({ data }: any) => {
        if (data.pdfUrl) {
          window.open(data.pdfUrl, "_blank");
        } else {
          notify("The PDF Url doesn't exist.", "warning");
        }
      })
      .catch((error: any) => {
        notify(`Error : ${error.message}`, "error");
      });
  };

  const getPdfUrlForUnpostedCn = () => {
    provider
      .customGetOne(`unpostedCreditNotes/creditNoteNo/${documentNo}`)
      .then(({ data }: any) => {
        if (data.pdfUrl) {
          window.open(data.pdfUrl, "_blank");
        } else {
          notify("The PDF Url doesn't exist.", "warning");
        }
      })
      .catch((error: any) => {
        notify(`Error : ${error.message}`, "error");
      });
  };

  return (
    <>
      {(docType === "IN" || docType === "CN") && (
        <StyledButton
          variant="outlined"
          onClick={() => (isUnposted ? getPdfUrlForUnpostedCn() : getPdfUrl())}
        >
          Show PDF
        </StyledButton>
      )}
    </>
  );
};

export default ShowPdfButton;
